import { FC } from 'react';
import { Text, TextProps } from '@chakra-ui/react';
import { RewardsActivityCardType, transactionDisplay } from '../../types/RewardsActivityCard';
import { getTransactionColor } from './transactionColor';
export interface CbRewardsActivityCardTransactionProps extends TextProps {
  transactionType: RewardsActivityCardType['transactionType'];
}
export const CbRewardsActivityCardTransaction: FC<CbRewardsActivityCardTransactionProps> = ({
  transactionType,
  ...props
}) => {
  const transactionColor = getTransactionColor(transactionType);
  const color = transactionColor || 'spyro.500';
  if (!transactionType) return null;
  return <Text border="1px solid" borderColor={color} borderRadius={8} color={color} display="inline-block" fontSize="sm" marginRight={2} padding="1px 10px" whiteSpace="nowrap" {...props} data-sentry-element="Text" data-sentry-component="CbRewardsActivityCardTransaction" data-sentry-source-file="CbRewardsActivityCardTransaction.tsx">
        {transactionDisplay[transactionType]?.title}
      </Text>;
};